import { useEffect, useMemo } from 'react';
import { type UseFormSetValue } from 'react-hook-form';

import { DictTypes } from '@/constants';
import { setDictionaryOptions } from '@/services';
import { useAppSelector } from '@/store';

import type { CreateLeasingProps } from '../../../widgets/create-tab';

type TProps = {
  getValues: () => CreateLeasingProps;
  setValue: UseFormSetValue<CreateLeasingProps>;
};

const useInitialData = ({ getValues, setValue }: TProps) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const mainActivities = useMemo(
    () =>
      setDictionaryOptions(DictTypes.MainActivities, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const countries = useMemo(
    () =>
      setDictionaryOptions(DictTypes.Countries, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const propertyTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.PropertyTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const registrationPlaces = useMemo(
    () =>
      setDictionaryOptions(DictTypes.DocumentIssuringAuthorities, dicts)?.map(
        (item) => ({
          value: String(item.value),
          label: String(item.label)
        })
      ) || [],
    [dicts]
  );

  useEffect(() => {
    const values = getValues();
    if (!values.typeOfProperty) {
      setValue('typeOfProperty', mainActivities[0]?.value || '');
    }
    if (!values.country) {
      setValue(
        'country',
        countries.find((item) => item.value === '99')?.label || ''
      );
    }
    if (!values.typeOfProperty) {
      setValue('typeOfProperty', propertyTypes[0]?.value || '');
    }
    if (!values.registrationPlace) {
      setValue('registrationPlace', registrationPlaces[0]?.value || '');
    }
  }, [countries, propertyTypes, registrationPlaces]);

  return {
    mainActivities,
    countries,
    propertyTypes,
    registrationPlaces
  };
};

export default useInitialData;
